<script setup lang="ts">
import { ref, useDebounceFn, watch } from '#imports'

withDefaults(defineProps<{ isLight?: boolean }>(), {
  isLight: false,
})

const emits = defineEmits(['destination-query-change', 'focus'])

const modelValue = defineModel<string>()

const emitDestinationQueryChange = useDebounceFn((val: string | null) => {
  emits('destination-query-change', val?.length ? val : null)
}, 350)

watch(modelValue, (val) => {
  if (!val) {
    return
  }
  emitDestinationQueryChange(val)
})

const destinationsInputEl = ref<HTMLInputElement>()

defineExpose({
  destinationsInputEl,
})
</script>

<template>
  <div class="relative h-full">
    <label
      v-if="!isLight"
      class="pointer-events-none absolute left-0 top-0 px-4 md:pt-5 font-semibold"
      for="search-query-destination"
    >
      <slot name="destination-label">{{ $t('data.search.destination.placeholder') }}</slot>
    </label>
    <input
      id="search-query-destination"
      ref="destinationsInputEl"
      :value="modelValue"
      type="text"
      name="destination"
      :placeholder="isLight ? $t('data.search.destination.placeholder') : $t('data.search.destination.label')"
      :class="isLight ? 'py-4' : 'pb-6 pt-7 md:pt-12'"
      class="h-full w-full appearance-none truncate border-b md:border-b-0 md:border-r border-gray-300 pr-11 outline-none pl-4 placeholder:text-gray-400 focus:placeholder:text-gray-300 text-black bg-transparent"
      @input="(event) => (modelValue = (event.target as HTMLInputElement).value)"
      @focus="emits('focus')"
    >
  </div>
</template>
